// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"50":"c0a6e2fb","82":"f9730ae5","127":"d9b5e68a","462":"1017f99d"}[chunkId] + ".chunk.css";
};